<template>
  <svg
    :width="width"
    :height="height"
    :viewBox="`0 0 ${width} ${height}`"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_2793_18912)">
      <path
        d="M22.7365 5.27651C22.7362 5.27662 22.736 5.27676 22.7357 5.27688L18.0412 7.30813C17.6895 7.4603 17.1206 7.45973 16.7705 7.3068C16.4205 7.15389 16.4219 6.90656 16.7736 6.75438L19.9255 5.39063L0.898438 5.39063C0.402231 5.39063 9.64331e-08 5.21574 1.05863e-07 5C1.15294e-07 4.78426 0.402231 4.60938 0.898438 4.60938L19.9254 4.60938L16.7736 3.24563C16.4219 3.09344 16.4206 2.84612 16.7706 2.69321C17.1207 2.54026 17.6896 2.53973 18.0412 2.69188L22.7357 4.72313C22.736 4.72325 22.7362 4.72338 22.7365 4.7235C23.0884 4.87619 23.0873 5.12432 22.7365 5.27651Z"
        :fill="fill"
      />
    </g>
    <defs>
      <clipPath id="clip0_2793_18912">
        <rect
          width="23"
          height="10"
          fill="white"
          transform="matrix(1 4.37114e-08 4.37114e-08 -1 0 10)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script setup lang="ts">
interface IProps {
  width?: number;
  height?: number;
  fill?: string;
  hoverFill?: string;
}

const props = withDefaults(defineProps<IProps>(), {
  width: 23,
  height: 10,
  fill: "#00B242",
  hoverFill: "#4B4B4B",
});
</script>

<script lang="ts">
export default {};
</script>
